import { h } from 'preact';
import Choice, { ChoiceItem as SkapaChoiceItem, ChoiceItemProps, ChoiceProps } from '@ingka/choice';
import { PREFIX } from 'DesignSystem/constants';
import './choice.scss';

export const ChoiceItem = (props: ChoiceItemProps) => <SkapaChoiceItem prefix={PREFIX} {...props} />;

export default (props: ChoiceProps) => <Choice prefix={PREFIX} {...props} />;
